module.exports = __webpack_public_path__ + "static/media/ETANG_EQ_INTERIEUR_RED.49d806f0.webp";